// let categories = [
// {
//   "value": "Rosemary",
//   "valueHighlighted": "Rose<em>mary</em>",
// },
// {
//   "value": "Rose",
//   "valueHighlighted": "<em>Rose</em>",
// }
// ]

let customDesiredCategoriesOrder = ["Rosemary", "Rose"];

let customDesiredCategoriesOrderOils = [
  "Hair Oils",
  "Essential Oils",
  "Cold Pressed Oils",
  "Face Oils",
  "Skin Oils",
  "Aroma Oils",
  "Massage Oils",
];

let customDesiredCategoriesOrderSoaps = ["Organic Soaps", "Natural Soaps"];

let customDesiredCategoriesOrderShampoos = [
  "Organic Shampoo Bars",
  "Natural Shampoo for Hair",
];

let customDesiredCategoriesOrderEssential = ["Pure Organic Essential Oils"];

let customDesiredCategoriesOrderSerum = ["Hair Serums", "Serum for Skin"];

let customDesiredCategoriesOrderCaster = ["Hair Oils", "Skin Oils"];

let customDesiredCategoriesOrderHairOils = [
  "Hair Oils",
  "Hair Growth",
  " Hair Serum",
  "SHampoo for Hair Growth",
];

let customDesiredCategoriesOrderVitaminC = ["Vitamin C Serum for Glow Skin"];

function updateCategories(categories, desiredCategoriesOrder) {
  let existingCategoriesMap = {};
  categories.forEach((category, index) => {
    existingCategoriesMap[category.value] = index;
  });

  let newCategories = [];
  desiredCategoriesOrder.forEach((desiredCategory) => {
    if (existingCategoriesMap.hasOwnProperty(desiredCategory)) {
      let existingIndex = existingCategoriesMap[desiredCategory];
      newCategories.push(categories[existingIndex]);
      delete existingCategoriesMap[desiredCategory];
    } else {
      newCategories.push({
        value: desiredCategory,
        valueHighlighted: `<em>${desiredCategory}</em>`,
      });
    }
  });

  for (let category in existingCategoriesMap) {
    newCategories.push(categories[existingCategoriesMap[category]]);
  }

  return newCategories;
}

//////////////////////////////////////////////////////////////////////////////////

let customOrder = [
  {
    value: "Rosemary Water",
    valueHighlighted: "<em>Rosemary</em> Water",
  },
  {
    value: "Rosemary for Hair Growth",
    valueHighlighted: "<em>Rosemary</em> for Hair Growth",
  },
  {
    value: "Rosemary Hair Oil",
    valueHighlighted: "<em>Rosemary</em> Hair Oil",
  },
  {
    value: "Rosemary Redensyl Hair Growth Serum",
    valueHighlighted: "<em>Rosemary</em> Redensyl Hair Growth Serum",
  },
  {
    value: "Rosemary Essential Oil",
    valueHighlighted: "<em>Rosemary</em> Essential Oil",
  },
];

let customOil = [
  {
    value: "Oils for Skin",
    valueHighlighted: "<em>Oils</em> for Skin",
  },
  {
    value: "Oils for Face",
    valueHighlighted: "<em>Oils</em> for Face",
  },
  {
    value: "Carrier Oils",
    valueHighlighted: "Carrier <em>Oils</em>",
  },
  {
    value: "Oil for Dandruff",
    valueHighlighted: "<em>Oil</em> for Dandruff",
  },
  {
    value: "Oil for Hair Growth",
    valueHighlighted: "<em>Oil</em> for Hair Growth",
  },
];

let customTeaTree = [
  {
    value: "Tea Tree for Acne",
    valueHighlighted: "<em>Tea Tree</em> for Acne",
  },
  {
    value: "Tea Tree for Dandruff",
    valueHighlighted: "<em>Tea Tree</em> for Dandruff",
  },
  {
    value: "Tea Tree Massage Oils",
    valueHighlighted: "<em>Tea Tree</em> Massage Oils",
  },
  {
    value: "Rosemary Tea Tree Shampoo",
    valueHighlighted: "Rosemary <em>Tea Tree</em> Shampoo",
  },
  {
    value: "Tea Tree Facewash",
    valueHighlighted: "<em>Tea Tree</em> Face Wash",
  },
  {
    value: "Tea Tree Essential Oil",
    valueHighlighted: "<em>Tea Tree</em> Essential Oil",
  },
];

let customSoaps = [
  {
    value: "Soap for Body Odour",
    valueHighlighted: "<em>Soap</em> for Body Odour",
  },
  {
    value: "Anti Tan Soap",
    valueHighlighted: "Anti Tan <em>Soap</em>",
  },
  {
    value: "Skin Brightening Soap",
    valueHighlighted: "Skin Brightening <em>Soap</em>",
  },
];

let customShampoos = [
  {
    value: "Shampoo for Dry Scalp",
    valueHighlighted: "<em>Shampoo</em> for Dry Scalp",
  },
  {
    value: "Shampoo for Smooth Hair",
    valueHighlighted: "<em>Shampoo</em> for Smooth Hair",
  },
  {
    value: "Shampoo for Dandruff",
    valueHighlighted: "<em>Shampoo</em> for Dandruff",
  },
];

let customSerums = [
  {
    value: "Serums for improve Skin Texture",
    valueHighlighted: "<em>Serums</em> for improve Skin Texture",
  },
  {
    value: "Serums for Acne",
    valueHighlighted: "<em>Serums</em> for Acne",
  },
  {
    value: "Serums for Hair Growth",
    valueHighlighted: "<em>Serums</em> for Hair Growth",
  },
];

let customEssentialOilHairGrowth = [
  {
    value: "Essential Oil for Skin",
    valueHighlighted: "<em>Essential</em> Oil for Skin",
  },
  {
    value: "Essential Oil for Dandruff",
    valueHighlighted: "<em>Essential</em> Oil for Dandruff",
  },
  {
    value: "Essential oil Hair Growth",
    valueHighlighted: "<em>Essential</em> oil Hair Growth",
  },
];

let customCastorHairOils = [
  {
    value: "Castor Skin Oils",
    valueHighlighted: "<em>Castor</em> Skin Oils",
  },
  {
    value: "Castor Hair Oils",
    valueHighlighted: "<em>Castor</em> Hair Oils",
  },
];

let customHairOilsReverse = [
  {
    value: "Hair Oils for Dry Scalp",
    valueHighlighted: "<em>Hair</em> Oils for Dry Scalp",
  },
  {
    value: "Hair Oils for Dandruff",
    valueHighlighted: "<em>Hair</em> Oils for Dandruff",
  },
  {
    value: "Hair Oils for Growth",
    valueHighlighted: "<em>Hair</em> Oils for Growth",
  },
  {
    value: "Carrier Oils",
    valueHighlighted: "<em>Carrier</em> Oils",
  },
];

let customVitaminC = [
  {
    value: "Vitamin C Facewash",
    valueHighlighted: "<em>Vitamin</em> C Facewash",
  },
  {
    value: "Vitamin C Sunscreen",
    valueHighlighted: "<em>Vitamin</em> C Sunscreen",
  },
];

let customHairGrowth = [
  {
    value: "Shampoo Bars ",
    valueHighlighted: "Shampoo <em>Bars</em>",
  },
  {
    value: "Shampoo for Hair Growth",
    valueHighlighted: "Shampoo for <em>Hair Growth</em>",
  },
  {
    value: "Hair Growth Oils",
    valueHighlighted: "<em>Hair Growth</em> Oils",
  },
  {
    value: "Essential Oil for Hair Growth",
    valueHighlighted: "Essential Oil for <em>Hair Growth</em>",
  },
];

function pushTopTrendingSearchesIntoSuggestions(suggestions, customOrder) {
  let existingSuggestionsMap = {};
  suggestions.forEach((suggestion, index) => {
    existingSuggestionsMap[suggestion.value] = index;
  });

  customOrder.forEach((desiredSearch) => {
    let searchValue = desiredSearch.value;
    let searchValueHighlighted = desiredSearch.valueHighlighted;

    if (existingSuggestionsMap.hasOwnProperty(searchValue)) {
      let existingIndex = existingSuggestionsMap[searchValue];
      suggestions[existingIndex].value = searchValue;
      suggestions[existingIndex].valueHighlighted = searchValueHighlighted;
    } else {
      suggestions.unshift({
        value: searchValue,
        valueHighlighted: searchValueHighlighted,
      });
      existingSuggestionsMap[searchValue] = suggestions.length - 1;
    }
  });
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const changeTemplate = function (div) {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;
  oldDiv.text = newDiv;
};

window.onWizzyScriptLoaded = function () {
  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-autocomplete-topproducts");
  changeTemplate("wizzy-search-empty-results");

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      console.log(data,"BEFORE_LAZY_INIT")
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (data) {
      // console.log(data," <= AFTER_WIZZY_API_RESPONDED");

      ///////////////////////////////////////////////////////////////////////////////
      if (data.response.payload.others) {
        if (
          document.querySelector(".wizzy-search-input").value.toLowerCase() ===
          "rose"
        ) {
          let suggestions = data.response.payload.others;
          pushTopTrendingSearchesIntoSuggestions(suggestions, customOrder);

          let array = data.response.payload.others;
          let map = new Map();
          let uniqueArray = [];

          array.forEach((item) => {
            if (!map.has(item.value)) {
              map.set(item.value, item);
              uniqueArray.push(item);
            }
          });

          data.response.payload.others = uniqueArray;
          console.log(uniqueArray);

          let categories = data.response.payload.categories;
          let updatedCategories = updateCategories(
            categories,
            customDesiredCategoriesOrder
          );
          data.response.payload.categories = updatedCategories;
        }
      }
      ////////////////////////////////////////////////////////////////////////////////////
      if (data.response.payload.others) {
        if (
          document.querySelector(".wizzy-search-input").value.toLowerCase() ===
          "rosemary"
        ) {
          let suggestions = data.response.payload.others;
          pushTopTrendingSearchesIntoSuggestions(suggestions, customOrder);

          let array = data.response.payload.others;
          let map = new Map();
          let uniqueArray = [];

          array.forEach((item) => {
            if (!map.has(item.value)) {
              map.set(item.value, item);
              uniqueArray.push(item);
            }
          });
          data.response.payload.others = uniqueArray;
          // console.log(uniqueArray);
        }
      }

      ///////////////////////////////////////////////////////////////////////////////////////
      if (data.response.payload.others) {
        if (
          document.querySelector(".wizzy-search-input").value.toLowerCase() ===
            "oil" ||
          document.querySelector(".wizzy-search-input").value.toLowerCase() ===
            "oils"
        ) {
          let suggestions = data.response.payload.others;
          pushTopTrendingSearchesIntoSuggestions(suggestions, customOil);

          let array = data.response.payload.others;
          let map = new Map();
          let uniqueArray = [];

          array.forEach((item) => {
            if (!map.has(item.value)) {
              map.set(item.value, item);
              uniqueArray.push(item);
            }
          });

          data.response.payload.others = uniqueArray;
          // console.log(uniqueArray);

          let categories = data.response.payload.categories;
          let updatedCategories = updateCategories(
            categories,
            customDesiredCategoriesOrderOils
          );
          data.response.payload.categories = updatedCategories;
        }
      }
      ////////////////////////////////////////////////////////////////////////////////////
      if (data.response.payload.others) {
        if (
          document.querySelector(".wizzy-search-input").value.toLowerCase() ===
          "tea tree"
        ) {
          let suggestions = data.response.payload.others;
          pushTopTrendingSearchesIntoSuggestions(suggestions, customTeaTree);

          let array = data.response.payload.others;
          let map = new Map();
          let uniqueArray = [];

          array.forEach((item) => {
            if (!map.has(item.value)) {
              map.set(item.value, item);
              uniqueArray.push(item);
            }
          });

          data.response.payload.others = uniqueArray;
          // console.log(uniqueArray);
        }
      }
      ////////////////////////////////////////////////////////////////////////////////////
      if (data.response.payload.others) {
        if (
          document.querySelector(".wizzy-search-input").value.toLowerCase() ===
          "soap"
        ) {
          let suggestions = data.response.payload.others;
          pushTopTrendingSearchesIntoSuggestions(suggestions, customSoaps);

          let array = data.response.payload.others;
          let map = new Map();
          let uniqueArray = [];

          array.forEach((item) => {
            if (!map.has(item.value)) {
              map.set(item.value, item);
              uniqueArray.push(item);
            }
          });

          data.response.payload.others = uniqueArray;
          // console.log(uniqueArray);

          let categories = data.response.payload.categories;
          let updatedCategories = updateCategories(
            categories,
            customDesiredCategoriesOrderSoaps
          );
          data.response.payload.categories = updatedCategories;
        }
      }
      ////////////////////////////////////////////////////////////////////////////////////
      if (data.response.payload.others) {
        if (
          document.querySelector(".wizzy-search-input").value.toLowerCase() ===
          "shampoo"
        ) {
          let suggestions = data.response.payload.others;
          pushTopTrendingSearchesIntoSuggestions(suggestions, customShampoos);

          let array = data.response.payload.others;
          let map = new Map();
          let uniqueArray = [];

          array.forEach((item) => {
            if (!map.has(item.value)) {
              map.set(item.value, item);
              uniqueArray.push(item);
            }
          });

          data.response.payload.others = uniqueArray;
          // console.log(uniqueArray);

          let categories = data.response.payload.categories;
          let updatedCategories = updateCategories(
            categories,
            customDesiredCategoriesOrderShampoos
          );
          data.response.payload.categories = updatedCategories;
        }
      }
      ////////////////////////////////////////////////////////////////////////////////////
      if (data.response.payload.others) {
        if (
          document.querySelector(".wizzy-search-input").value.toLowerCase() ===
          "serum"
        ) {
          let suggestions = data.response.payload.others;
          pushTopTrendingSearchesIntoSuggestions(suggestions, customSerums);

          let array = data.response.payload.others;
          let map = new Map();
          let uniqueArray = [];

          array.forEach((item) => {
            if (!map.has(item.value)) {
              map.set(item.value, item);
              uniqueArray.push(item);
            }
          });

          data.response.payload.others = uniqueArray;
          console.log(uniqueArray);

          let categories = data.response.payload.categories;
          let updatedCategories = updateCategories(
            categories,
            customDesiredCategoriesOrderSerum
          );
          data.response.payload.categories = updatedCategories;
        }
      }
      ////////////////////////////////////////////////////////////////////////////////////
      if (data.response.payload.others) {
        const searchInputValue = document
          .querySelector(".wizzy-search-input")
          .value.toLowerCase();
        if (
          ["essential oil", "essential oils", "essential"].includes(
            searchInputValue
          )
        ) {
          let suggestions = data.response.payload.others;
          pushTopTrendingSearchesIntoSuggestions(
            suggestions,
            customEssentialOilHairGrowth
          );

          let array = data.response.payload.others;
          let map = new Map();
          let uniqueArray = [];

          array.forEach((item) => {
            if (!map.has(item.value)) {
              map.set(item.value, item);
              uniqueArray.push(item);
            }
          });

          data.response.payload.others = uniqueArray;
          // console.log(uniqueArray);

          let categories = data.response.payload.categories;
          let updatedCategories = updateCategories(
            categories,
            customDesiredCategoriesOrderEssential
          );
          data.response.payload.categories = updatedCategories;
        }
      }
      ////////////////////////////////////////////////////////////////////////////////////
      if (data.response.payload.others) {
        if (
          document.querySelector(".wizzy-search-input").value.toLowerCase() ===
          "castor"
        ) {
          let suggestions = data.response.payload.others;
          pushTopTrendingSearchesIntoSuggestions(
            suggestions,
            customCastorHairOils
          );

          let array = data.response.payload.others;
          let map = new Map();
          let uniqueArray = [];

          array.forEach((item) => {
            if (!map.has(item.value)) {
              map.set(item.value, item);
              uniqueArray.push(item);
            }
          });

          data.response.payload.others = uniqueArray;
          // console.log(uniqueArray);

          let categories = data.response.payload.categories;
          let updatedCategories = updateCategories(
            categories,
            customDesiredCategoriesOrderCaster
          );
          data.response.payload.categories = updatedCategories;
        }
      }
      ////////////////////////////////////////////////////////////////////////////////////
      if (data.response.payload.others) {
        const searchInputValue = document
          .querySelector(".wizzy-search-input")
          .value.toLowerCase();
        if (["hair oils", "hair oil", "hair"].includes(searchInputValue)) {
          let suggestions = data.response.payload.others;
          pushTopTrendingSearchesIntoSuggestions(
            suggestions,
            customHairOilsReverse
          );

          let array = data.response.payload.others;
          let map = new Map();
          let uniqueArray = [];

          array.forEach((item) => {
            if (!map.has(item.value)) {
              map.set(item.value, item);
              uniqueArray.push(item);
            }
          });

          data.response.payload.others = uniqueArray;
          data.response.payload.others = data.response.payload.others.filter(
            (item) => item.value !== "Hair Oils for Stretch Marks"
          );

          data.response.payload.others = uniqueArray;
          // console.log(uniqueArray);

          let categories = data.response.payload.categories;
          let updatedCategories = updateCategories(
            categories,
            customDesiredCategoriesOrderHairOils
          );
          data.response.payload.categories = updatedCategories;

          console.log(uniqueArray);
        }
      }
      ////////////////////////////////////////////////////////////////////////////////////

      if (data.response.payload.others) {
        const searchInputValue = document
          .querySelector(".wizzy-search-input")
          .value.toLowerCase();
        if (["vitamin", "vitamin c"].includes(searchInputValue)) {
          let suggestions = data.response.payload.others;
          pushTopTrendingSearchesIntoSuggestions(suggestions, customVitaminC);

          let array = data.response.payload.others;
          let map = new Map();
          let uniqueArray = [];

          array.forEach((item) => {
            if (!map.has(item.value)) {
              map.set(item.value, item);
              uniqueArray.push(item);
            }
          });

          data.response.payload.others = uniqueArray;
          // console.log(uniqueArray);

          let categories = data.response.payload.categories;
          let updatedCategories = updateCategories(
            categories,
            customDesiredCategoriesOrderVitaminC
          );
          data.response.payload.categories = updatedCategories;

          console.log(uniqueArray);
        }
      }
      ////////////////////////////////////////////////////////////////////////////////////

      if (data.response.payload.others) {
        const searchInputValue = document
          .querySelector(".wizzy-search-input")
          .value.toLowerCase();
        if (["hair growth"].includes(searchInputValue)) {
          let suggestions = data.response.payload.others;
          pushTopTrendingSearchesIntoSuggestions(suggestions, customHairGrowth);

          let array = data.response.payload.others;
          let map = new Map();
          let uniqueArray = [];

          array.forEach((item) => {
            if (!map.has(item.value)) {
              map.set(item.value, item);
              uniqueArray.push(item);
            }
          });

          data.response.payload.others = uniqueArray;
          // console.log(uniqueArray);
        }
      }
      ////////////////////////////////////////////////////////////////////////////////////

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      // console.log(data," < === BEFORE_AUTOCOMPLETE_EXECUTED")

      data.sort = [
        {
          field: "relevance",
          order: "asc",
        },
        {
          field: "product_WizzyScore_tags:float",
          order: "desc",
        },
      ];

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      // console.log(data.sort," < === BEFORE_SEARCH_EXECUTED")

      if (data.sort) {
        if (data.sort[0].field === "relevance" && data.sort.length == 1) {
          data.sort.push({
            field: "product_WizzyScore_tags:float",
            order: "desc",
          });
        }
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      // console.log(data.filters," < === BEFORE_FILTERS_EXECUTED")

      if (data.filters.sort) {
        if (
          data.filters.sort[0].field === "relevance" &&
          data.filters.sort.length == 1
        ) {
          data.filters.sort.push({
            field: "product_WizzyScore_tags:float",
            order: "desc",
          });
        }
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      let x = document.querySelector(".wizzy-body-end-wrapper");
      if (
        x &&
        typeof data.isForDefault !== "undefined" &&
        data.isForDefault === true
      ) {
        x.classList.add("wizzy-view-more-hide");
      } else if (x && x.classList.contains("wizzy-view-more-hide")) {
        x.classList.remove("wizzy-view-more-hide");
      }

      if(document.documentElement.clientWidth < 768){
        if(data.payload){
          if(data.payload){
            if(data.payload.others && data.payload.others.length > 0){
              data.payload.others = data.payload.others.slice(0,1);
            }
            if(data.payload.products){
              if(data.payload.products.filters){
                if(data.payload.products.filters.q){
                  if(data.payload.products.filters.q.length > 0){
                    data.payload.others = [];
                  }
                }
              }
            }
            if(data.payload.categories && data.payload.categories.length>0){
              data.payload.categories = data.payload.categories.slice(0,1);
            }
            if(data.payload.pages && data.payload.pages.length>0){
              data.payload.pages = data.payload.pages.slice(0,0);
            }
          }
        }
      }

      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      // console.log(data," < == AFTER_PRODUCTS_TRANSFORMED");

      data.forEach((product) => {
        product.newLaunch = false;
        // product.trendingTag = false;
        // product.newTag = false;
        // product.plusTag = false;
        // product.preLaunchTag = false;
        // product.soldOutTag = false;
        // if(product.inStock === false) product.soldOutTag=true;
        product.attributes.forEach((attribute) => {
          if (attribute.id === "product_tags") {
            //    if (attribute.values.some(value => value.value.includes('Badge1: NEW LAUNCH'))) {
            //   product.plusTag = true;
            // }
            if (
              attribute.values.some((value) => /NEW LAUNCH/.test(value.value))
            ) {
              product.newLaunch = true;
            }
            // if (attribute.values.some(value => value.value.includes('Trending'))) {
            //   product.trendingTag = true;
            // }
            // if (attribute.values.some(value => value.value.includes('New'))) {
            //   product.newTag = true;
            // }
            // if (attribute.values.some(value => value.value.includes('Best-Seller'))) {
            //   product.preLaunchTag = true;
            // }
          }
        });
      });

      if (data.length == 1) {
        // console.log("Only single product found for this one...");
        setTimeout(function () {
          var selectedFiltersBlock = document.querySelector(
            ".wizzy-selected-filters .wizzy-filters-selected-facets-block"
          );
          if (selectedFiltersBlock) {
            selectedFiltersBlock.style.display = "block";
            selectedFiltersBlock.style.marginTop = "45px";
          }
        }, 500);
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log(data," < === VIEW_RENDERED");

      //////////////////////////////////////////////////////////////////////////////////////////////////////////

      const facetBlocks = document.querySelectorAll(
        ".wizzy-filters-facet-block"
      );

      facetBlocks.forEach((facetBlock) => {
        facetBlock.addEventListener("click", () => {
          const isCollapsed = facetBlock.classList.contains("collapsed");

          // Collapse all facet blocks except the clicked one
          facetBlocks.forEach((block) => {
            if (block !== facetBlock) {
              block.classList.add("collapsed");
            }
          });

          if (isCollapsed) {
            // console.log(isCollapsed,"removed");
            facetBlock.classList.add("collapsed");
          } else {
            // console.log(isCollapsed,"added");
            facetBlock.classList.remove("collapsed");
          }
        });
      });

      ///////////////////////////////////////////////////////////////////////////////////////////////////////////

      const allFacetBlocks = document.querySelectorAll(
        ".wizzy-filters-facet-block"
      );
      allFacetBlocks.forEach((facetBlock) => {
        // console.log("added");
        facetBlock.classList.add("collapsed");
      });

      setTimeout(function () {
        var facetList = document.querySelector(".wizzy-selected-facet-list");

        if (facetList) {
          var existingClearAllLink = facetList.querySelector(
            ".wizzy-filters-clear-all"
          );

          if (!existingClearAllLink) {
            var clearAllLink = document.createElement("a");
            clearAllLink.href = "#";
            clearAllLink.className = "wizzy-filters-clear-all";
            clearAllLink.textContent = "Remove all";

            facetList.appendChild(clearAllLink);
          }
        }
      }, 500);

      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      if (data.data.api === "search" || data.data.api === "filter") {
        var element = document.querySelector(
          ".wizzy-filters-facet-block .facet-head-right"
        );

        if (element) {
          element.click();
        } else {
          console.log("Element not found.");
        }
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      // console.log(data," < === PRODUCTS_CACHED_RESULTS_RENDERED");

      //////////////////////////////////////////////////////////////////////////////////////////////////////////

      const facetBlocks = document.querySelectorAll(
        ".wizzy-filters-facet-block"
      );

      facetBlocks.forEach((facetBlock) => {
        facetBlock.addEventListener("click", () => {
          const isCollapsed = facetBlock.classList.contains("collapsed");

          facetBlocks.forEach((block) => {
            if (block !== facetBlock) {
              block.classList.add("collapsed");
            }
          });

          if (isCollapsed) {
            facetBlock.classList.add("collapsed");
          } else {
            facetBlock.classList.remove("collapsed");
          }
        });
      });

      ///////////////////////////////////////////////////////////////////////////////////////////////////////////

      const allFacetBlocks = document.querySelectorAll(
        ".wizzy-filters-facet-block"
      );
      allFacetBlocks.forEach((facetBlock) => {
        // console.log("added");
        facetBlock.classList.add("collapsed");
      });

      setTimeout(function () {
        var facetList = document.querySelector(".wizzy-selected-facet-list");

        if (facetList) {
          var existingClearAllLink = facetList.querySelector(
            ".wizzy-filters-clear-all"
          );

          if (!existingClearAllLink) {
            var clearAllLink = document.createElement("a");
            clearAllLink.href = "#";
            clearAllLink.className = "wizzy-filters-clear-all";
            clearAllLink.textContent = "Remove all";

            facetList.appendChild(clearAllLink);
          }
        }
      }, 500);

      return data;
    }
  );

  ////////////////////////////////////////////////

  var searchIcon = document.querySelector(".header__icon.header__icon--search");

  searchIcon.addEventListener("click", function () {
    setTimeout(function () {
      var searchInput = document.querySelector(
        ".search__input.wizzy-search-input"
      );

      if (searchInput) {
        searchInput.click();
      }
    }, 500);
  });
};



window.addEventListener('scroll', function() {
    var scrollPercentage = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;

    if (scrollPercentage >= 1) {
        document.body.classList.add('wizzy-scroll');
    } else {
        document.body.classList.remove('wizzy-scroll');
    }
});